import { observer } from 'mobx-react-lite'
import { Navigate } from 'react-router-dom'
import { useActiveUsers } from 'app/components/active-users/useActiveUsers'
import { ActiveUsersShadcnComponent } from 'app/components/active-users/ActiveUsersShadcnComponent'
import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { useManageUsersPageAccess } from 'app/hooks/useManageUsersPageAccess'

export default observer(function ActiveUsers(): React.ReactElement {
  const checkPermission = useCheckPermission()
  const { me, isOrgUser, canEditUser } = useManageUsersPageAccess()
  const { users, columns, filters, initialSort } = useActiveUsers()

  if (!me) return <></>

  if (!me.workspaceId) {
    return <Navigate to="/settings/users" replace />
  }

  // Super users and org users can always access
  // Workspace users need users:manage permission
  const canManageUsers = me.type === `super` || isOrgUser || checkPermission(`users:manage`)
  if (!canManageUsers) {
    return <Navigate to="/" replace />
  }

  return (
    <ActiveUsersShadcnComponent
      users={users}
      columns={columns}
      filters={filters}
      initialSort={initialSort}
      canManageUsers={canManageUsers}
      canEditUser={canEditUser}
      isOrgUser={isOrgUser}
      isSuperUser={me.type === `super`}
    />
  )
})
